import { getIndividualResultCasinoAPI } from "../../service/casino";
import { getProfit } from "../../utils/constants";
import { casinoPL } from "../../utils/profitLoss";
import React, { useState, useEffect } from "react";
import MarketResultA from "./MarketResultA";
import { useLocation } from "react-router-dom";
import MarketResultB from "./MarketResultB";

export const getUniversalCasinoPlExposureByRunner = (
  data,
  runnerName,
  selectionId
) => {
  if (!data || !data.length > 0) return null;
  let exp = 0;
  let found = false;
  data.forEach((item) => {
    if (selectionId) {
      const foundExposure = item?.casinoPLExposure?.find(
        (exposure) =>
          selectionId === exposure.selectionId &&
          runnerName?.toLowerCase() === exposure.selectionName?.toLowerCase()
      );
      if (foundExposure) {
        exp += foundExposure.exposure;
        found = true;
      }
    } else {
      const foundExposure = item?.casinoPLExposure?.find(
        (exposure) =>
          runnerName?.toLowerCase() === exposure.selectionName?.toLowerCase()
      );
      if (foundExposure) {
        exp += foundExposure.exposure;
        found = true;
      }
    }
  });
  if (!found) return null;
  return (
    <div _ngcontent-ng-c2991413133="" className="d-flex align-items-center p-0">
      <span
        _ngcontent-ng-c2991413133=""
        className="p-0 ng-star-inserted"
        style={{ display: "flex", fontSize: 15, fontWeight: 400 }}
      >
        <span
          _ngcontent-ng-c2991413133=""
          style={{ fontWeight: "bold !important" }}
          className="ng-star-inserted"
        >
          {" "}
          {exp < 0 ? "L" : "P"} :
        </span>

        <span
          _ngcontent-ng-c2991413133=""
          className={`d-flex ${
            exp < 0 ? "minus" : "plus"
          }-book ng-star-inserted`}
        >
          {" "}
          {exp}
        </span>
      </span>
    </div>
  );
};
export const getUniversalCasinoBallByBallPlExposureByRunner = (
  data,
  runnerName,
  selectionId
) => {
  if (!data || !data.length > 0) return null;
  let exp = 0;
  let found = false;
  data.forEach((item) => {
    if (selectionId) {
      const foundExposure = item?.casinoPLExposure?.find(
        (exposure) =>
          selectionId === exposure.selectionId &&
          runnerName?.toLowerCase() === exposure.selectionName?.toLowerCase()
      );
      if (foundExposure) {
        exp += foundExposure.exposure;
        found = true;
      }
    } else {
      const foundExposure = item?.casinoPLExposure?.find(
        (exposure) =>
          runnerName?.toLowerCase() === exposure.selectionName?.toLowerCase()
      );
      if (foundExposure) {
        exp += foundExposure.exposure;
        found = true;
      }
    }
  });
  if (!found) return null;
  return (
    <span
      _ngcontent-ng-c2991413133=""
      style={{
        fontWeight: "bold !important",
        color: exp < 0 ? "red" : "green",
      }}
      className="ng-star-inserted"
    >
      {" "}
      {exp}
    </span>
  );
};
export const getUniversalCasinoPrePlExposureByRunner = (
  data,
  runnerName,
  selectionId,
  marketId
) => {
  if (!data) return null;
  let isBack = false;
  if (data?.back) {
    isBack = true;
  }
  if (data?.lay) {
    isBack = false;
  }
  let selectionId_ = data?.marketIdWithSelectionId?.split("_")[1];
  let marketId_ = data?.marketIdWithSelectionId?.split("_")[0];
  let profit = 0;
  let loss = 0;

  let calculatedPL = casinoPL(
    data?.back,
    data?.amount,
    isBack ? "back" : "lay"
  );
  profit = calculatedPL.profit;
  loss = calculatedPL.loss;
  let runnerName_ = data?.runnerName;

  if (!data) return null;
  if (!selectionId) return null;
  if (!marketId) return null;
  if (!runnerName_) return null;
  if (marketId != marketId_) return null;
  return (
    <div _ngcontent-ng-c2991413133="" className="d-flex align-items-center p-0">
      <span
        _ngcontent-ng-c2991413133=""
        className="p-0 ng-star-inserted"
        style={{ display: "flex", fontSize: 15, fontWeight: 400 }}
      >
        <span
          _ngcontent-ng-c2991413133=""
          style={{ fontWeight: "bold !important" }}
          className="ng-star-inserted"
        >
          {" "}
          {selectionId != selectionId_ ? "L" : "P"} :
        </span>

        <span
          _ngcontent-ng-c2991413133=""
          className={`d-flex ${selectionId_ == selectionId ? "plus" : "minus"
            }-book ng-star-inserted`}
        >
          {" "}
          {selectionId == selectionId_ ? profit : loss}
        </span>
      </span>
    </div>
  );
};
export const UNIVERSAL_EXTRA_CARDS = {
  SPADES: " ♠",
  HEARTS: " ♥",
  DIAMONDS: " ♦",
  CLUBS: " ♣",
};
export const getOddsByRunner = (data, runnerName, fullObj = false) => {
  let data_ = data;
  if (!data_) return null;
  let found = false;
  let odds = 0;
  for (let i = 0; i < data_?.markets?.length; i++) {
    const foundRunner = data_?.markets[i]?.oddDetailsDTO?.find(
      (runner) => runnerName?.toLowerCase() === runner.runnerName?.toLowerCase()
    );
    if (foundRunner) {
      if (fullObj)
        return { ...foundRunner, marketId: data_?.markets[i]?.marketId };
      odds = foundRunner?.back1;
      found = true;
      break;
    }
  }
  if (!found) return null;
  return odds;
};
const resultColorMap = {
  a: "casino-a",
  b: "casino-b",
  c: "casino-a",
  t: "tigerResult",
  d: "casino-a",
  l: "loinResult",
  r: "casino-a",
  p: "baccarat-player",
  l: "casino-b",
  h: "casino-a",
};
const baccaratResultColorMap = {
  p: "baccarat-player",
  b: "baccarat-Banker",
  t: "baccarat-Tie",
};
const inaMinaDikaResultColorMap = {
  d: "casino-c",
  i: "casino-a",
  m: "casino-b",
};

export const GetUniversalLastTenResult = ({ lastResult, casinoGames }) => {
  const isHeadsAndTails = casinoGames === "UNI_HEADS_AND_TAILS";

  const location = useLocation();
  const [casinoPath, setCasinoPath] = useState('');
  const [result, setLastResult] = React.useState({});
  const baseUrl = "https://casino.uniique444.com/assets/cards/";


  useEffect(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    const lastSegment = segments.pop();
    setCasinoPath(lastSegment);
  }, [location.pathname]);

const renderMarketComponent = () => {
    if (isHeadsAndTails) return <p className="text-center">Winner: {result.winner || "Pending"}</p>;
    switch (casinoPath) {
      case 'UNI_1_CARD_METER':
      case 'UNI_32_CARDS_B':
      case 'UNI_ANDAR_BAHAR_C':
        return <MarketResultB cards={result.cards} winner={result.winner} baseUrl={baseUrl}/>;
      default:
        return <MarketResultA cards={result.cards} winner={result.winner} baseUrl={baseUrl} />;
    }
};

const cupIcon = (result) => (
  <i
    className={result === "WINNER" ? "fa fa-trophy winner-icon" : "fa fa-trophy loser-icon"}
  />
);

return (
  <app-results _ngcontent-ng-c2991413133="" _nghost-ng-c3559087628="">
    <div _ngcontent-ng-c3559087628="" className="recent-res teenpatti">
      <h5 _ngcontent-ng-c3559087628="" style={{ fontWeight: "bold" }}>
        Recent Result
      </h5>
      <ul _ngcontent-ng-c3559087628="" className="result">
        {lastResult?.data?.map((result) => (
          <li
            _ngcontent-ng-c3559087628=""
            data-bs-toggle="modal"
            onClick={() => setLastResult(result)}
            data-bs-target="#resultModal"
            className={`${isHeadsAndTails ? `ht-result-${result?.winner?.slice(0, 1)?.toLowerCase() || "pending"}` : result?.eventName == "20-20 POKER - B"
              ? resultColorMap[result?.winner?.split(" ")[1]?.toLowerCase()]
              : result?.eventName?.startsWith("20-20 CARD RACE")
                ? ""
                : result?.eventName?.startsWith("BOLLYWOOD CASINO")
                  ? "casino-a"
                  : result?.eventName?.startsWith("INA MINA DIKA")
                    ? inaMinaDikaResultColorMap[
                    result?.winner?.toLowerCase()?.slice(0, 1)
                    ]
                    : result?.eventName?.startsWith("32 CARDS")
                      ? "casino-c"
                      : result?.eventName?.startsWith("BACCARAT")
                        ? baccaratResultColorMap[
                        result?.winner?.toLowerCase()?.slice(0, 1)
                        ]
                        : result?.winner == "TIE"
                          ? "casino-c"
                          : resultColorMap[result?.winner?.toLowerCase()?.slice(0, 1)]
              }`}
          >
            {result?.eventName?.startsWith("20-20 CARD RACE") ? (
              <a _ngcontent-ng-c3559087628="" className="number text-dark"
              >
                <img
                  _ngcontent-ng-c3559087628=""
                  className="imgClass"
                  src={`https://casino.queenexch.com/assets/cards/${result?.winner}_.png`}
                />
              </a>
            ) : (
              <a
                style={
                  result?.eventName?.startsWith("BACCARAT")
                    ? {
                      color: "white ",
                    }
                    : {}
                }
                _ngcontent-ng-c3559087628=""
                className="number"
              >
                {result?.eventName == "20-20 POKER - B"
                  ? result?.winner?.split(" ")[1]
                  : result?.eventName?.startsWith("32 CARDS")
                    ? result?.winner?.split("_")[1]
                    : result?.winner?.slice(0, 1).toUpperCase()}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>

    <div
      _ngcontent-ng-c3559087628=""
      id="resultModal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      className="modal fade"
      style={{ overflowY: "hidden", position: "fixed" }}
    >
      <div _ngcontent-ng-c3559087628="" className="modal-dialog">
        <div _ngcontent-ng-c3559087628="" className="modal-content">
          <div
            _ngcontent-ng-c3559087628=""
            className="modal-header bet-slip-head"
          >
            <h6
              _ngcontent-ng-c3559087628=""
              id="exampleModalLabel"
              className="modal-title"
            >
              <b
                _ngcontent-ng-c3559087628=""
                style={{ textTransform: "capitalize", fontSize: 15 }}
              >{result?.eventName}</b>
            </h6>
            <button
              _ngcontent-ng-c3559087628=""
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              className="close"
            >
              ×
            </button>
          </div>
          <div
            _ngcontent-ng-c3559087628=""
            id="__BVID__33___BV_modal_body_"
            className="modal-body"
          >
            <div style={{ marginBottom: 80 }}>
              <div className="modal-title pb-2">
                <h6 className="text-right round-id">
                  <b>Round Id: {result?.roundId}</b>
                </h6>
              </div>

               {renderMarketComponent()}

              <div _ngcontent-ng-c3559087628 className="clearfix mt-2"></div>

              {result?.results?.map((resultItem, idx) => {
                if (isHeadsAndTails && resultItem?.runnerName) {
                  return <div key={idx} className="card-Img-box sectionA p-1">{resultItem.runnerName} - {cupIcon(resultItem.result)}</div>;
                }
                const { marketName, runners = [], runnersName = {} } = resultItem || {};
                return (
                  <div key={idx}>
                    <div className="col-md-12 col-xs-12 all-market-winner">
                      <h6 className="text-center eventName">{marketName}</h6>

                      {Object.entries(runnersName || {}).map(([selectionId, playerLabel]) => {
                        const playerResult = runners.find(r => r.selectionId === selectionId)?.result;

                        return (
                          <div key={selectionId} className={`card-Img-box sectionA p-1`}>
                            {playerLabel} - {cupIcon(playerResult)}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}

              <div className="clearfix" _ngcontent-ng-c3559087628></div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div
      _ngcontent-ng-c3559087628=""
      id="CardRaceModal"
      tabIndex={-1}
      aria-labelledby="CardRaceModal"
      aria-hidden="true"
      className="modal fade"
    >
      <div _ngcontent-ng-c3559087628="" className="modal-dialog">
        <div _ngcontent-ng-c3559087628="" className="modal-content">
          <div
            _ngcontent-ng-c3559087628=""
            className="modal-header bet-slip-head"
          >
            <h5
              _ngcontent-ng-c3559087628=""
              id="exampleModalLabel"
              className="modal-title"
            >
              <b
                _ngcontent-ng-c3559087628=""
                style={{ textTransform: "capitalize" }}
              ></b>
            </h5>
            <button
              _ngcontent-ng-c3559087628=""
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              className="close"
            >
              ×
            </button>
          </div>
          <div
            _ngcontent-ng-c3559087628=""
            id="__BVID__33___BV_modal_body_"
            className="modal-body"
          >
            <div _ngcontent-ng-c3559087628="" style={{ marginBottom: 80 }}>
              <div
                _ngcontent-ng-c3559087628=""
                className="modal-title p-2"
                style={{ float: "left" }}
              >
                <h6
                  _ngcontent-ng-c3559087628=""
                  className="text-right round-id"
                >
                  <b _ngcontent-ng-c3559087628="">Round Id:</b>
                </h6>
              </div>
              <div
                _ngcontent-ng-c3559087628=""
                className="col-12 col-md-12 col-xs-12 paati_boxs"
              >
                <ul _ngcontent-ng-c3559087628="" className="showall-card">
                  <img
                    _ngcontent-ng-c3559087628=""
                    src="../../../../assets/cards/CK_.png"
                    className="imgClassModal"
                  />
                  <span _ngcontent-ng-c3559087628="" className="ms-1">
                    -
                  </span>
                </ul>
                <ul _ngcontent-ng-c3559087628="" className="showall-card">
                  <img
                    _ngcontent-ng-c3559087628=""
                    src="../../../../assets/cards/DK_.png"
                    className="imgClassModal"
                  />
                  <span _ngcontent-ng-c3559087628="" className="ms-1">
                    -
                  </span>
                </ul>
                <ul _ngcontent-ng-c3559087628="" className="showall-card">
                  <img
                    _ngcontent-ng-c3559087628=""
                    src="../../../../assets/cards/HK_.png"
                    className="imgClassModal"
                  />
                  <span _ngcontent-ng-c3559087628="" className="ms-1">
                    -
                  </span>
                </ul>
                <ul _ngcontent-ng-c3559087628="" className="showall-card">
                  <img
                    _ngcontent-ng-c3559087628=""
                    src="../../../../assets/cards/SK_.png"
                    className="imgClassModal"
                  />
                  <span _ngcontent-ng-c3559087628="" className="ms-1">
                    -
                  </span>
                </ul>
              </div>
              <div _ngcontent-ng-c3559087628="" className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-results>
);
};
